module.exports = __webpack_public_path__ + "static/img/P4.df842f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/P4.png
// module id = 3Wv1
// module chunks = 0